import * as React from 'react'
import { useActions } from './useActions'
import { DraftLeadListViewProps } from './typings'
import { WWMXGrid } from '@user/components/xGrid'

import { GridDensity, GridState, GridValidRowModel } from '@mui/x-data-grid-pro'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

import {
  defaultDraftLeadColumns,
  defaultDraftLeadColVis,
  lockedDraftLeadColumns,
} from './draftLeadColumns'

import {
  IUserPreferenceGeneralListItemType,
  saveGeneralPreferences,
  userGeneralPreferencesList,
} from '@user/store/userPreferences/userPreferencesGeneral'

import { DraftLeadBulkActions } from './DraftLeadBulkActions'
import { formatInitialPhoneNumberValue } from '@user/components/Leads/AddLeadForm/utils'

export const DraftLeadListView: React.FC<DraftLeadListViewProps> = (props) => {
  const {
    loading,
    page,
    perPage,
    count,
    columns,
    rows,
    columnVisibility,
    exportClickCallback,
  } = props

  const dispatch = useAppDispatch()

  const userGeneralPreferences = useSelector(userGeneralPreferencesList)

  const {
    handlePaginationModelChange,
    sortModel,
    onSortModelChange,
    onSaveColumnState,
    selectionChangeCallback,
    onColumnWidthChange,
  } = useActions(props)

  const densityModeUserGeneralPreference = userGeneralPreferences?.find(
    (row) =>
      row?.type == IUserPreferenceGeneralListItemType.DraftLeadDensityMode,
  )

  const stringValue = densityModeUserGeneralPreference?.value ?? 'standard'
  const densityMode = stringValue as GridDensity

  const onStateChange = (state: GridState) => {
    if (state.density) {
      onDensityChange(state.density.value)
    }
  }

  const onDensityChange = (density: string) => {
    if (densityMode != density) {
      dispatch(
        saveGeneralPreferences({
          type: IUserPreferenceGeneralListItemType.DraftLeadDensityMode,
          value: density,
        }),
      )
    }
  }

  function formattedRows() {
    return rows?.map((row: GridValidRowModel) => {
      return {
        ...row,
        phoneNumber: formatInitialPhoneNumberValue(row?.phoneNumber),
      }
    })
  }

  return (
    <WWMXGrid
      loading={loading}
      columnVisibilityModel={columnVisibility}
      // columns
      columns={columns}
      onColumnWidthChange={(e) =>
        onColumnWidthChange(e?.colDef, columns, columnVisibility)
      }
      columnsSelectorProps={{
        saveCallback: (e) => onSaveColumnState(e, columns),
        lockedColumns: lockedDraftLeadColumns,
        defaultColumns: defaultDraftLeadColumns,
        defaultVisibility: defaultDraftLeadColVis,
      }}
      BulkActions={DraftLeadBulkActions}
      //state
      isDensityEnable
      isExportEnable
      density={densityMode}
      onStateChange={onStateChange}
      //export
      exportClickCallback={exportClickCallback}
      // rows
      rows={formattedRows()}
      rowCount={count}
      // pagination
      paginationModel={{ page: page - 1, pageSize: perPage }}
      onPaginationModelChange={handlePaginationModelChange}
      // sorting
      sortModel={sortModel}
      onSortModelChange={onSortModelChange}
      selectionChangeCallback={selectionChangeCallback}
      width="100%"
    />
  )
}
DraftLeadListView.displayName = 'DraftLeadListView'
